import { isbot } from 'isbot';

/**
 * @returns {boolean} True if the current request is from a known synthetic agent
 * or common web crawler/bot.
 */
export function isMonitoringAgentOrBot(): boolean {
  // 1. Dedicated Synthetic Agent Variables
  // eslint-disable-next-line no-underscore-dangle
  if (window._DATADOG_SYNTHETICS_BROWSER) {
    return true;
  }

  return isbot(navigator.userAgent);
}

/**
 * Checks if the DOM is available in the current environment.
 * @returns {boolean} True if the window object is defined (DOM is available), false otherwise.
 */
export function isDOMAvailable(): boolean {
  return typeof window !== 'undefined';
}

/**
 * Checks the `prefers-reduced-motion: reduce` media query.
 * @returns {boolean} True if the user has requested reduced motion.
 */
export function prefersReducedMotion(): boolean {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 * Downloads a blob as a file in the browser
 * @param blob - The blob to download
 * @param filename - The name for the downloaded file
 */
export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
}
